import styled from 'styled-components';
export const Content = styled.div`
  flex: 1 1 100%;
  /* Allow a $overflow Content to become the bounded scroller in a flex-column
     Page instead of forcing an ancestor #page to scroll. Without min-height: 0
     the default min-height: auto keeps this flex child sized to its intrinsic
     content, so its own overflow: auto never activates. Fixes wheel-scroll
     failing over Content (e.g. Customer Portal notification settings). */
  min-height: 0;
`;
